import { Pipe, PipeTransform } from '@angular/core';

import {
  CSGO_Extras,
  Dota2_Extras,
  Rust_Extras,
  SteamApp
} from '../items.entity';
import { getItemExterior } from '../utils';

@Pipe({
  name: 'itemExterior'
})
export class ItemExteriorPipe implements PipeTransform {
  transform(extras: CSGO_Extras|Dota2_Extras|Rust_Extras|null, appId: SteamApp): string {
    return getItemExterior(extras, appId);
  }
}